/* ==========================================================================
   MICHEL PIZA · bag drawer and discount codes · October 2026
   1. Bag drawer: the bag icon opens it instead of the bag page, and a pair
      added from a product page opens it too (in place of the theme's small
      pop-up). Markup: snippets/mp-cart-drawer.liquid.
   2. Discount codes, in the drawer and on the bag page. Shopify keeps the
      code on the bag and carries it to checkout.
   3. Sizes on collection pages add the pair to the bag directly.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var body = document.body;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function each(selector, fn, scope) { toArray((scope || document).querySelectorAll(selector)).forEach(fn); }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var t = window.theme;
    if (t && t.Currency && typeof t.Currency.formatMoney === 'function' && t.moneyFormat) {
      return t.Currency.formatMoney(cents, t.moneyFormat);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
  }
  function sized(url, width) {
    if (!url) { return ''; }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function request(path, data) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (data) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }
    return window.fetch(root + path, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) { throw json; }
        return json;
      });
    });
  }
  function getCart() { return request('cart.js'); }

  // The number on the bag icon in the menu bar.
  function setCount(count) {
    each('[data-cart-count]', function (el) { el.textContent = count > 0 ? String(count) : ''; });
    each('[data-cart-count-bubble]', function (el) { el.classList.toggle('hide', !(count > 0)); });
  }

  /* ------------------------------------------------------------------
     2. DISCOUNT CODES
     ------------------------------------------------------------------ */
  // Amount saved per discount, from line discounts and order discounts.
  function savings(cart) {
    var byTitle = {};
    var order = [];
    function add(application, amount) {
      if (!application) { return; }
      var title = application.title || '';
      var key = title.toLowerCase();
      if (!byTitle[key]) {
        byTitle[key] = { title: title, amount: 0 };
        order.push(key);
      }
      byTitle[key].amount += amount || 0;
    }
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        add(allocation.discount_application, allocation.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      add(application, application.total_allocated_amount);
    });
    return order.map(function (key) { return byTitle[key]; });
  }

  function appliedCodes(cart) {
    return ((cart && cart.discount_codes) || [])
      .filter(function (entry) { return entry.applicable; })
      .map(function (entry) { return entry.code; });
  }

  function codesHtml(cart) {
    var saved = savings(cart);
    var codes = appliedCodes(cart);
    var rows = codes.map(function (code) {
      var hit = saved.filter(function (s) { return s.title.toLowerCase() === code.toLowerCase(); })[0];
      return '<li class="mp-discount__code">' +
        '<span class="mp-discount__name">' + esc(code) + '</span>' +
        (hit && hit.amount ? '<span class="mp-discount__amount">&minus;' + esc(money(hit.amount)) + '</span>' : '') +
        '<button type="button" class="mp-discount__remove" data-mp-code-remove="' + esc(code) + '" aria-label="Remove code ' + esc(code) + '">Remove</button>' +
        '</li>';
    });
    // Automatic discounts (no code to remove).
    saved.forEach(function (s) {
      var isCode = codes.some(function (code) { return code.toLowerCase() === s.title.toLowerCase(); });
      if (isCode || !s.amount) { return; }
      rows.push('<li class="mp-discount__code"><span class="mp-discount__name">' + esc(s.title) + '</span>' +
        '<span class="mp-discount__amount">&minus;' + esc(money(s.amount)) + '</span></li>');
    });
    return rows.join('');
  }

  // box: [data-mp-discount]. onChange(cart) runs after a code is added or
  // removed: the drawer redraws, the bag page reloads.
  function initDiscount(box, onChange) {
    var input = box.querySelector('[data-mp-discount-input]');
    var apply = box.querySelector('[data-mp-discount-apply]');
    var list = box.querySelector('[data-mp-codes]');
    var note = box.querySelector('[data-mp-discount-message]');
    var current = null;
    if (!input || !apply || !list) { return null; }

    function say(text, isError) {
      if (!note) { return; }
      note.textContent = text || '';
      note.classList.toggle('is-error', !!isError);
    }
    function show(cart) {
      current = cart;
      list.innerHTML = codesHtml(cart);
    }
    function update(codes) {
      return request('cart/update.js', { discount: codes.join(',') });
    }
    function busy(on) { box.classList.toggle('is-busy', on); }

    function submit() {
      var code = (input.value || '').trim();
      if (!code) { say('Enter a code.', true); input.focus(); return; }
      if (box.classList.contains('is-busy')) { return; }
      var before = [];
      busy(true);
      say('');
      // Codes already on the bag stay; the new one is added to them.
      (current ? Promise.resolve(current) : getCart()).then(function (cart) {
        current = cart;
        before = appliedCodes(cart);
        if (before.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          say('This code is already applied.');
          return null;
        }
        return update(before.concat(code));
      }).then(function (cart) {
        if (!cart) { return null; }
        var entry = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (entry && entry.applicable) {
          input.value = '';
          say('Code applied.');
          return onChange(cart);
        }
        // Not valid for this bag: put the bag back as it was.
        return update(before).then(function (restored) {
          show(restored);
          say('This code cannot be used with this bag.', true);
        });
      }).catch(function () {
        say('The code could not be checked. Please try again.', true);
      }).then(function () { busy(false); });
    }

    apply.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      // Enter applies the code (and does not send the bag form around it).
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
    list.addEventListener('click', function (e) {
      var button = e.target.closest('[data-mp-code-remove]');
      if (!button) { return; }
      var code = button.getAttribute('data-mp-code-remove').toLowerCase();
      busy(true);
      update(appliedCodes(current).filter(function (c) { return c.toLowerCase() !== code; }))
        .then(function (cart) { say(''); return onChange(cart); })
        .catch(function () { say('The code could not be removed. Please try again.', true); })
        .then(function () { busy(false); });
    });

    return { show: show, say: say };
  }

  /* ------------------------------------------------------------------
     1. BAG DRAWER
     ------------------------------------------------------------------ */
  function initDrawer() {
    var drawer = document.querySelector('[data-mp-drawer]');
    if (!drawer || !window.fetch || body.classList.contains('template-cart')) { return; }
    html.classList.add('mp-has-drawer');

    var panel = drawer.querySelector('.mp-drawer__panel');
    var items = drawer.querySelector('[data-mp-drawer-items]');
    var count = drawer.querySelector('[data-mp-drawer-count]');
    var subtotal = drawer.querySelector('[data-mp-drawer-subtotal]');
    var closeButton = drawer.querySelector('.mp-drawer__close');
    var dustIds = (drawer.getAttribute('data-dustbag-ids') || '').split(',').filter(Boolean);
    var dustImage = drawer.getAttribute('data-dustbag-image');
    var discountBox = drawer.querySelector('[data-mp-discount]');
    var discount = null;
    var lastFocus = null;

    function lineHtml(item) {
      var options = (item.options_with_values || [])
        .filter(function (o) { return o.name !== 'Title'; })
        .map(function (o) { return '<p class="mp-drawer__meta">' + esc(o.name) + ': ' + esc(o.value) + '</p>'; })
        .join('');
      // Notes added with the pair, such as the sizing note on flats ("Fit").
      var props = item.properties || {};
      Object.keys(props).forEach(function (name) {
        var value = props[name];
        if (!value || name.charAt(0) === '_') { return; }
        options += name === 'Fit'
          ? '<p class="mp-drawer__meta mp-drawer__meta--note">' + esc(value) + '</p>'
          : '<p class="mp-drawer__meta">' + esc(name) + ': ' + esc(value) + '</p>';
      });
      var price = item.final_line_price < item.original_line_price
        ? '<s>' + esc(money(item.original_line_price)) + '</s>' + esc(money(item.final_line_price))
        : esc(money(item.final_line_price));
      var image = item.image
        ? '<img src="' + esc(sized(item.image, 240)) + '" alt="" width="112" height="140" loading="lazy">'
        : '';
      return '<li class="mp-drawer__item">' +
        '<a class="mp-drawer__image" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
        '<div class="mp-drawer__info">' +
          '<a class="mp-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          options +
          '<p class="mp-drawer__meta">Qty ' + esc(item.quantity) + '</p>' +
          '<p class="mp-drawer__price">' + price + '</p>' +
          '<button type="button" class="mp-drawer__remove" data-mp-remove="' + esc(item.key) + '" aria-label="Remove ' + esc(item.product_title) + '">Remove</button>' +
        '</div>' +
        '</li>';
    }
    // One (Dust)Bag with every pair, as on the bag page.
    function dustHtml(pairs) {
      return '<li class="mp-drawer__item mp-drawer__item--gift">' +
        '<span class="mp-drawer__image">' + (dustImage ? '<img src="' + esc(dustImage) + '" alt="" width="112" height="140" loading="lazy">' : '') + '</span>' +
        '<div class="mp-drawer__info">' +
          '<span class="mp-drawer__name">(Dust)Bag</span>' +
          '<p class="mp-drawer__meta mp-drawer__meta--note">Crafted from upcycled fabrics. No two are alike; colours and patterns may differ from the image shown.</p>' +
          '<p class="mp-drawer__meta">Qty ' + pairs + '</p>' +
          '<p class="mp-drawer__price">Complimentary</p>' +
        '</div>' +
        '</li>';
    }
    function render(cart) {
      var pairs = 0;
      (cart.items || []).forEach(function (item) {
        if (dustIds.indexOf(String(item.product_id)) === -1) { pairs += item.quantity; }
      });
      setCount(cart.item_count);
      count.textContent = '(' + cart.item_count + ')';
      drawer.classList.toggle('is-empty', !cart.item_count);
      items.innerHTML = (cart.items || []).map(lineHtml).join('') + (pairs > 0 ? dustHtml(pairs) : '');
      subtotal.textContent = money(cart.total_price);
      if (discount) { discount.show(cart); }
    }
    function refresh() {
      return getCart().then(render).catch(function () { /* keep what is shown */ });
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') { return; }
      var focusables = toArray(panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
      if (!focusables.length) { return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      refresh();
      if (drawer.classList.contains('is-open')) { return; }
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      html.classList.add('mp-drawer-open');
      document.addEventListener('keydown', onKey);
      window.setTimeout(function () {
        try { closeButton.focus({ preventScroll: true }); } catch (err) { closeButton.focus(); }
      }, 80);
    }
    function close() {
      if (!drawer.classList.contains('is-open')) { return; }
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      html.classList.remove('mp-drawer-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (err) { /* nothing to return to */ }
      }
    }

    if (discountBox) { discount = initDiscount(discountBox, render); }

    // First content from the page itself, so the drawer opens filled.
    try {
      var initial = drawer.querySelector('[data-mp-cart-json]');
      if (initial) { render(JSON.parse(initial.textContent)); }
    } catch (err) { /* filled on open */ }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-mp-drawer-close]')) { e.preventDefault(); close(); return; }
      var remove = e.target.closest('[data-mp-remove]');
      if (!remove) { return; }
      var row = remove.closest('.mp-drawer__item');
      if (row) { row.classList.add('is-removing'); }
      request('cart/change.js', { id: remove.getAttribute('data-mp-remove'), quantity: 0 })
        .then(render)
        .catch(refresh);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-mp-bag-open]');
      if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      e.preventDefault();
      open();
    });

    // "Add to bag": the theme shows its pop-up; close it and open the drawer.
    var popup = document.querySelector('[data-cart-popup-wrapper]');
    if (popup && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (popup.classList.contains('cart-popup-wrapper--hidden')) { return; }
        var dismiss = popup.querySelector('[data-cart-popup-close]');
        if (dismiss) { dismiss.click(); }
        open();
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    }

    window.MPBag = { open: open, close: close, refresh: refresh };
  }

  /* ------------------------------------------------------------------
     3. SIZES ON COLLECTION PAGES
     An available size under a product adds that pair to the bag and opens
     the drawer, without going to the product page. Flats carry their
     sizing note (data-mp-fit on the card) as a line item property, so it
     shows in the bag and at checkout.
     ------------------------------------------------------------------ */
  function initQuickAdd() {
    if (!window.fetch) { return; }
    document.addEventListener('click', function (e) {
      var size = e.target.closest ? e.target.closest('[data-mp-quick-add]') : null;
      if (!size) { return; }
      e.preventDefault();
      if (size.getAttribute('aria-busy') === 'true') { return; }
      var card = size.closest('.product-card');
      var fit = card ? card.getAttribute('data-mp-fit') : '';
      var item = { id: Number(size.getAttribute('data-mp-quick-add')), quantity: 1 };
      if (fit) { item.properties = { Fit: fit }; }
      size.setAttribute('aria-busy', 'true');
      size.classList.remove('is-error');
      size.removeAttribute('title');
      request('cart/add.js', { items: [item] })
        .then(function () {
          if (window.MPBag) { return window.MPBag.open(); }
          return getCart().then(function (cart) { setCount(cart.item_count); });
        })
        .catch(function (err) {
          // For example: all the pairs in that size are already in the bag.
          size.classList.add('is-error');
          size.setAttribute('title', (err && (err.description || err.message)) || 'This size could not be added.');
        })
        .then(function () { size.removeAttribute('aria-busy'); });
    });
  }

  /* Product page of a flat: the same note goes with the pair from the
     product form (window.mpFitNote comes from snippets/mp-head.liquid). */
  function initFitNote() {
    var note = window.mpFitNote;
    if (!note || !body.classList.contains('template-product')) { return; }
    each('form[action*="/cart/add"]', function (form) {
      if (form.querySelector('input[name="properties[Fit]"]')) { return; }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Fit]';
      input.value = note;
      form.appendChild(input);
    });
  }

  /* Bag page: the discount field reloads the page so every price and the
     subtotal are redrawn by Shopify. */
  function initCartPage() {
    if (!body.classList.contains('template-cart') || !window.fetch) { return; }
    var box = document.querySelector('[data-mp-discount]');
    if (!box) { return; }
    var discount = initDiscount(box, function () { window.location.reload(); });
    if (!discount) { return; }
    getCart().then(function (cart) { discount.show(cart); }).catch(function () { /* field still works */ });
  }

  ready(function () {
    try { initDrawer(); } catch (e) { if (window.console) { console.warn('[mp] bag drawer', e); } }
    try { initCartPage(); } catch (e) { if (window.console) { console.warn('[mp] bag discount', e); } }
    try { initQuickAdd(); } catch (e) { if (window.console) { console.warn('[mp] quick add', e); } }
    try { initFitNote(); } catch (e) { if (window.console) { console.warn('[mp] fit note', e); } }
  });
})();
